<template>
  <div
    class="filter__input-group"
    :data-id="filter_on + '_' + blockInput.value.value"
  >
    <div
      class="filter__checkbox-container"
      @click="checkBlock(blockInput)"
    >
      <input
        :id="blockInput.value.value"
        type="checkbox"
        class="filter__checkbox"
        :value="blockInput.value.value"
        :checked="checkboxChecked"
      >
    </div>
    <label
      :for="blockInput.value.value"
      class="filter__label"
    >{{
      blockInput.link.name.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())
    }}</label>
  </div>
</template>

<script>
export default {
  name: 'SingleBlockInput',
  delimiters: ['{$', '$}'],
  props: {
    blockInput: Object,
    filter_on: String,
    ___inpTD: Object,
    allSelectedFilters__: Array,
  },
  data() {
    return {
      checkboxChecked: false,
      _isSearchTemplate: window.location.pathname.includes('/search')
        ? true
        : false,
    }
  },
  computed: {
    filteredOnVals() {
      return this.$store.getters.getFilteredOnValues
    },
  },

  watch: {
    ___inpTD: {
      deep: true,
      handler: function(newValue, oldValue) {
        this.unCheckBlock(newValue, this.blockInput)
      },
    },

    allSelectedFilters__: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (this.allSelectedFilters__.length == 0) {
          this.uncheckAllFilters()
        }
        if (this.allSelectedFilters__[0] != undefined) {
          this.$nextTick(() => {
            if (!this._isSearchTemplate) {
              this.checkBlockFromParams(this.allSelectedFilters__)
            }
          })
        }
      },
    },
  },

  beforeMount() {
    this.isSearchTemplate = window.location.pathname.includes('/search')
      ? true
      : false
  },

  mounted() {
    if (this.allSelectedFilters__[0] != undefined) {
      this.$nextTick(() => {
        if (!this._isSearchTemplate) {
          this.checkBlockFromParams(this.allSelectedFilters__)
        }
      })
    }
  },
  methods: {
    checkBlock: function(data, input) {
      const that = this
      const isSearchTemplate = window.location.pathname.includes('/search')
        ? true
        : false

      const name = data.link.name
      const value = data.value.value
      const filter_on_ = that.filter_on

      if (that.checkboxChecked == true) {
        that.checkboxChecked = false
        if (!this.isSearchTemplate) {
          this.$emit('removeFilter', [filter_on_, value])
        }
      } else {
        that.checkboxChecked = true
        if (!this.isSearchTemplate) {
          this.generateFiltersUrlAdd(filter_on_, value)
        }
      }

      const inputObj = {
        checked: that.checkboxChecked,
        filter_on: filter_on_,
        name: name,
        value: value,
      }

      this.$emit('singleObjectCheck', inputObj)
    },

    checkBlockFromParams: function(data) {
      const that = this
      data.forEach(item => {
        const blockInputValue = item.filter_on + '_' + item.value

        if (blockInputValue == that.$el.dataset.id) {
          that.checkboxChecked = true
        }
      })
    },

    generateFiltersUrlAdd: function(group, value) {
      const currentSearchParam = new URLSearchParams(window.location.search)
      const initialFiltered = window.location.search
        ?.split('?filtered=[')[1]
        ?.split(']')[0]

      let filteredBy = ''

      if (initialFiltered) {
        filteredBy = initialFiltered + `&${group}=${value}`
      } else {
        filteredBy = `${group}=${value}`
      }

      const sortCheck = currentSearchParam.get('fh_sort_by')
      if (sortCheck) {
        window.history.pushState(
          {},
          '',
          window.location.pathname +
            '?filtered=[' +
            filteredBy +
            ']&fh_sort_by=' +
            sortCheck,
        )
      } else {
        window.history.pushState(
          {},
          '',
          window.location.pathname + '?filtered=[' + filteredBy + ']',
        )
      }
    },

    generateFiltersUrlRemove: function(group, value) {
      const currentSearchParam = new URLSearchParams(window.location.search)
      const initialFiltered = window.location.search
        ?.split('?filtered=[')[1]
        ?.split(']')[0]

      const filterToRemoveMulti = `&${group}=${value}`
      const filterToRemoveSingle = `${group}=${value}`

      if (initialFiltered) {
        let filteredBy = initialFiltered.replace(filterToRemoveMulti, '')
        filteredBy = filteredBy.replace(filterToRemoveSingle, '')

        if (filteredBy.substring(0, 1) == '&')
          filteredBy = filteredBy.slice(1, filteredBy.length)

        const sortCheck = currentSearchParam.get('fh_sort_by')

        if (filteredBy.length > 0) {
          // More than 1 filter initially.
          filteredBy = `?filtered=[${filteredBy}]`
        }

        if (sortCheck) {
          const _urlParams =
            (filteredBy.length > 0 ? filteredBy + '&' : '?') +
            'fh_sort_by=' +
            sortCheck
          window.history.pushState(
            {},
            '',
            window.location.pathname + _urlParams,
          )
        } else {
          window.history.pushState(
            {},
            '',
            window.location.pathname + filteredBy,
          )
        }
      }
    },

    unCheckBlock: function(input, data) {
      const that = this
      const filter_on_ = that.filter_on
      const filterToDelete = filter_on_ + '_' + that.blockInput.value.value
      const filterInputValue = filter_on_ + '_' + input.value

      if (filterInputValue === filterToDelete) {
        this.checkboxChecked = false
        if (!this._isSearchTemplate) {
          const name = data.link.name
          const value = data.value.value
          this.generateFiltersUrlRemove(filter_on_, value)
        }
      }
    },

    uncheckAllFilters: function() {
      this.checkboxChecked = false
    },
  },
}
</script>
